import { DocumentOption } from '../types';

const secDocsSvg = `sec-doc.svg`;
const physicsSvg = `physics.svg`;
const csPapersSvg = `cs-papers.svg`;

export const DOCUMENT_OPTIONS: DocumentOption[] = [
    {
        id: "SEC Filings",
        name: "SEC Documents",
        icon: secDocsSvg,
        details: "Search through financial filings and corporate reports",
    },
    {
        id: "Physics",
        name: "Physics Papers",
        icon: physicsSvg,
        details: "Explore research in quantum mechanics and theoretical physics",
    },
    {
        id: "SC",
        name: "CS Papers",
        icon: csPapersSvg,
        details: "Discover algorithms, AI, and computer science research",
    },
];

export const getDefaultDocument = (): DocumentOption => DOCUMENT_OPTIONS[0];
